<template>
  <div class="row">
    <div class="col-12">
      <p class="text-right">
        <router-link class="btn btn-primary" :to="{ name: 'brands.create' }">
          <font-awesome-icon :icon="['fal', 'plus-circle']" />
          Create
        </router-link>
      </p>

      <v-server-table
        ref="table"
        url="/brands"
        :columns="columns"
        :options="options"
      ></v-server-table>
    </div>
  </div>
</template>

<script type="text/babel">
import entity from "../../mixins/entity";

export default {
  mixins: [entity],

  data() {
    return {
      columns: ["name", "actions"],
      options: {
        sortable: ["name"],
        columnsClasses: {
          actions: "text-center",
        },
        templates: {
          actions: (h, o) => this.entityEdit(h, o, "brands", this.$refs),
        },
      },
    };
  },
};
</script>
